import { FC } from 'react';

import { useI18n } from '#hooks/useI18n';

import { Can } from '#/components/roles/Can';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { Private } from '#/containers/router/routes/Private';

import { NavigationLink } from '../components/NavigationLink';

export const Supplies: FC<SectionProps> = ({ onClickItem, depth, isMobile }) => {
  const { t } = useI18n();

  return (
    <Can hasRoles={['buildingManager', 'admin']}>
      <NavigationLink
        to={Private.SUPPLIES.route}
        icon="mosaic"
        title={t('asideNavigation.supplies')}
        onClick={onClickItem}
        depth={depth}
        isMobile={isMobile}
      />
    </Can>
  );
};
